export const PickTypes = {
	Advancing: 1,
	ThreeWins: 2,
	NoWins: 3,
	Eliminated: 4,
	TopTeam: 5,
	SecondTeam: 6,
};
